import PopupAction from 'components/Misc/PopupActions/components/PopupAction';
import { Action } from 'helpers';
import { Divider } from '@mui/material';

function ManagementDeployPackagePopup({ object, level, onClose }) {
    return (
        <>
            <PopupAction action={Action.Edit} object={object} level={level} showLabel onActionHandled={onClose} />
            <Divider />
            <PopupAction
                action={Action.DeploymentPackageJob}
                object={object}
                level={level}
                showLabel
                onActionHandled={onClose}
            />
            <Divider />
            <PopupAction action={Action.Delete} object={object} level={level} showLabel onActionHandled={onClose} />
        </>
    );
}

export { ManagementDeployPackagePopup };
